import { render, staticRenderFns } from "./quanbuyouxi.vue?vue&type=template&id=be2b2486&scoped=true"
import script from "./quanbuyouxi.vue?vue&type=script&lang=js"
export * from "./quanbuyouxi.vue?vue&type=script&lang=js"
import style0 from "./quanbuyouxi.vue?vue&type=style&index=0&id=be2b2486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2b2486",
  null
  
)

export default component.exports